import * as React from 'react'

function SvgComponent(props) {
	return (
		<svg
			width={30}
			height={30}
			viewBox='0 0 30 30'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M29.063 6.416c-1.055.458-2.172.76-3.314.896a5.714 5.714 0 002.539-3.14 11.586 11.586 0 01-3.666 1.377A5.81 5.81 0 0020.41 3.75c-3.189 0-5.77 2.543-5.77 5.678-.002.436.048.87.15 1.295A16.447 16.447 0 012.894 4.787a5.607 5.607 0 00-.785 2.854c0 1.968 1.028 3.709 2.579 4.728a5.714 5.714 0 01-2.624-.709v.07c0 2.754 1.992 5.045 4.629 5.567-.496.132-1.007.199-1.52.2a5.53 5.53 0 01-1.085-.106c.733 2.256 2.866 3.896 5.394 3.943a11.694 11.694 0 01-7.168 2.432c-.46-.001-.92-.028-1.377-.082A16.33 16.33 0 009.77 26.25c10.627 0 16.432-8.654 16.432-16.16 0-.246-.007-.492-.018-.733a11.63 11.63 0 002.878-2.941z'
				fill='#f9f9f9'
			/>
		</svg>
	)
}

export default SvgComponent
